var map = {
	"./a4g.svg": "095e",
	"./a4gb.svg": "65d6",
	"./apple-store-badge.svg": "dbc1",
	"./background.svg": "a762",
	"./btc.svg": "6fe1",
	"./eth.svg": "b872",
	"./jinni.svg": "2d5d",
	"./logo.svg": "9b19",
	"./logobe.svg": "96d2",
	"./logobew.svg": "79a4",
	"./p4g_icon.svg": "0a3e",
	"./roct.svg": "98ec",
	"./t4g.svg": "691e",
	"./t4gbrl.svg": "3cee",
	"./t4gcad.svg": "e54d",
	"./t4gclp.svg": "e451",
	"./tether.svg": "2a2c",
	"./ticket/fail.svg": "b6ba",
	"./ticket/success.svg": "e19c",
	"./ticket/system.svg": "e509",
	"./usdc.svg": "6a14",
	"./wallet4good.svg": "14cd",
	"./wallet4good_reverse.svg": "d04a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";